//hook
import { useEffect } from "react";

//lib
import { toast, ToastContainer } from "react-toastify";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom"; // for routing - to do navigation between different components

//scss
import "./scss/components/_element.scss";
import "./scss/index.scss";
import "react-toastify/dist/ReactToastify.css";
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/effect-fade";

//page
import Home from "./pages/home";
import Shop from "./pages/shop";
import Product from "./pages/product";

//component
import MainLayout from "./components/layout/main.layout";

//service
import httpService from "./services/http.service";
import Cart from "./pages/cart";
import Order from "./pages/order";
import AboutUs from "./pages/about-us";

function App() {
  useEffect(() => {
    httpService.initializeInterceptors(toast);
  }, []);

  return (
    <BrowserRouter>
      <ToastContainer
        limit={1}
        autoClose={3000}
        pauseOnHover={false}
        pauseOnFocusLoss={false}
      />
      <Routes>
        <Route
          path="/"
          element={
            <MainLayout>
              <Home />
            </MainLayout>
          }
        />
        <Route
          path="/about-us"
          element={
            <MainLayout>
              <AboutUs />
            </MainLayout>
          }
        />
        <Route
          path="/shop/:category"
          element={
            <MainLayout className="--shop">
              <Shop />
            </MainLayout>
          }
        />
        <Route
          path="/product/:id"
          element={
            <MainLayout>
              <Product />
            </MainLayout>
          }
        />
        <Route
          path="/cart"
          element={
            <MainLayout>
              <Cart />
            </MainLayout>
          }
        />
        <Route
          path="/order"
          element={
            <MainLayout className="--order">
              <Order />
            </MainLayout>
          }
        />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
